export type ProductVisibility = 'visible' | 'hidden_from_shop' | 'hidden_from_search' | 'hidden_from_store_categories'

export interface ProductPageLinkProduct {
  product_in_location?: boolean | null
  visibility?: ProductVisibility | null
  hide_from_shop?: boolean | null
}

// Controls the bundle modal link, not access to a product's direct URL.
// The API supplies effective visibility, including inheritance and read cutover.
export function useProductPageLinkVisibility(product: ProductPageLinkProduct | null | undefined): boolean {
  if (!product?.product_in_location) return false

  if (product.visibility) return product.visibility !== 'hidden_from_shop'

  return !product.hide_from_shop
}
